{
  "title": "Присоединиться к CloudServer",
  "lead": "Вас приглашают в {{organization}} как: {{role}}. Укажите имя и задайте пароль.",
  "email": "E-mail",
  "name": "Ваше имя",
  "password": "Пароль",
  "passwordHint": "Не короче 12 символов.",
  "nextStep": "Затем вы добавите passkey или приложение-аутентификатор: здесь все входят со вторым фактором.",
  "submit": "Присоединиться",
  "signedIn": "Вы вошли под другой учётной записью. Выйдите, чтобы принять приглашение.",
  "invalidTitle": "Приглашение не работает",
  "invalidLead": "Ссылка уже использована, отозвана или старше 7 дней. Попросите администратора прислать новую.",
  "toSignIn": "Ко входу"
}
